export default __webpack_public_path__ + "static/media/PNB_PERSONAL.8e88d61d.svg";